import { useAtom } from "@reatom/npm-react";
import SvgSprite from "../Utils/SvgSprite";

import React, { useEffect, useState } from "react";

export function Modal({
    label, 
    children,
    caption,
    _atom,
    icon,
}){
    useState(()=>{
        function handleKeyDown(event) {
            if(event.key === 'Escape'){
                setOpen(false)
            }
        }
        window.addEventListener('keydown', handleKeyDown)
        return () => {
            window.removeEventListener('keydown', handleKeyDown)
        }
    }, [])

    const [open, setOpen] = useAtom(_atom)
    return (
        <div className={`modal -react ${open ? 'is--active' : ''}`} >
            <div className="modal__holder" onClick={(event) => {
                setOpen(false)
                event.stopPropagation()
            }}>
                <div className="modal__wrapper base-form" onClick={(event)=>{
                    event.stopPropagation()
                }}>
                    <div className="modal__header">
                        {icon && (
                            <div className="modal__icon">
                                <SvgSprite 
                                    id={icon}
                                />
                            </div>
                        )}
                        {label && (
                            <div className="heading -border -center">
                                {label}
                            </div>
                        )}
                        <div className="modal__action -close" onClick={() => {
                            console.log(setOpen)
                            setOpen(false)
                        }}>
                            <SvgSprite 
                                id="close"
                                />
                        </div>
                        {caption && (
                            <div class="modal__caption">
                                {caption}
                            </div>
                        )}
                    </div>
                    <div className="modal__body">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}